/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {EnrolmentRequestsList} from "@doctor-panel-modules/patient-personal-data/components/enrolment-requests-list/enrolment-requests-list";
import {ExternalProviderResolver} from "@modules/base/external-provider.resolver";
import {DocsAdministrationGuard} from "@modules/base/guards/docs-administration.guard";
import {IsFeatureAvailableGuard} from "@modules/base/guards/is-feature-available.guard";
import {IsPhysicianGuard} from "@modules/base/guards/is-physician.guard";
import {PatientIdResolver} from "@modules/base/guards/patient-id.resolver";
import {CreditsPageComponent} from "@modules/base/pages/credits-page/credits-page.component";
import {HomePageComponent} from "@modules/base/pages/home-page/home-page.component";
import {PatientGroupPageComponent} from "@modules/base/pages/patient-group-page/patient-group-page.component";
import {AuthGuard} from "@trec/api/guards";
import {TrecServices} from "./models/constants/trec-services";

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    component: HomePageComponent,
  },
  {
    path: "disclaimer",
    loadChildren: () =>
      import("app/modules/disclaimer/disclaimer.module").then((m) => m.DisclaimerModule),
    canActivate: [],
  },
  /*   {
      path: "questionnaire",
      loadChildren: () =>
        import("app/modules/questionnaire/questionnaire.module").then((m) => m.QuestionnaireModule),
      canActivate: [AuthGuard],
    }, */
  // {
  //   path: "questionnaires",
  //   loadChildren: () =>
  //     import("@modules/questionnaires/questionnaires.module").then((m) => m.QuestionnairesModule),
  //   canActivate: [AuthGuard],
  // },

  {
    path: "questionnaires",
    loadChildren: () =>
      import("@modules/questionnaires/routes").then((m) => m.routes),
    canActivate: [AuthGuard],
  },
  // {
  //   path: 'apps-tutorial',
  //   loadChildren: 'app/pages/apps-tutorial/apps-tutorial.module#AppsTutorialModule',
  //   canActivate: [AuthGuard]
  // },
  {
    path: "doctor-panel",
    loadChildren: () =>
      import("app/modules/doctor-panel/doctor-panel.module").then((m) => m.DoctorPanelModule),
    canActivate: [AuthGuard, IsPhysicianGuard], // TODO use PatientIdGuard?
    resolve: {
      patientId: PatientIdResolver,
    },
  },
  {
    path: "messages",
    loadChildren: () =>
      import("app/modules/messages/messages.module").then((m) => m.MessagesModule),
    canActivate: [AuthGuard], // IsPhysicianGuard
  },
  {
    path: "support",
    loadChildren: () => import("app/modules/support/support.module").then((m) => m.SupportModule),
    canActivate: [AuthGuard], // IsPhysicianGuard
  },
  {
    path: "video-meeting",
    loadChildren: () =>
      import("app/modules/video-meeting/video-meeting-page/video-meeting-page.module").then(
        (m) => m.VideoMeetingPageModule
      ),
    canActivate: [AuthGuard, IsFeatureAvailableGuard], // IsPhysicianGuard
    data: {
      [IsFeatureAvailableGuard.DATA_REQUIRED_FEATURE]: TrecServices.VideoChat,
    },
  },
  {
    path: "hospital-administration",
    canActivate: [DocsAdministrationGuard],
    component: DocsAdministrationGuard,
  },
  {
    path: "credits",
    component: CreditsPageComponent,
  },
  {
    path: "patient-group",
    component: PatientGroupPageComponent,
    canActivate: [AuthGuard], // IsPhysicianGuard
  },
  {
    path: "enrolment-requests",
    component: EnrolmentRequestsList,
    canActivate: [AuthGuard, IsPhysicianGuard],
  },


  // {
  //   path: 'help-guide',
  //   loadChildren: () => import('app/modules/help-guide/help-guide.module').then(m => m.HelpGuideModule),
  //   canActivate: [AuthGuard, IsPhysicianGuard]
  // },
  {
    path: "account",
    loadChildren: () => import("app/modules/account/account.module").then((m) => m.AccountModule),
    canActivate: [AuthGuard, IsPhysicianGuard],
  },
  {
    path: "external", // Route to external sites
    resolve: {
      data: ExternalProviderResolver,
    },
    loadChildren: () =>
      import("app/modules/not-found/not-found.module").then((m) => m.NotFoundModule),
  },
  {
    path: "**",
    loadChildren: () =>
      import("app/modules/not-found/not-found.module").then((m) => m.NotFoundModule),
  },
];

@NgModule({
  // Note: "scrollPositionRestoration" actually does not do anything since in the app it is not the content of the
  // "body" tag to scroll but the content of the "drawer-content" tag. Due to this, scrolling must be triggered manually
  // (it is done in AppComponent).
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: "always",
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
      //enableTracing: true
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
